export default __webpack_public_path__ + "static/media/Result_Table_Head.74bcc7d1.svg";